import { render, staticRenderFns } from "./ContactRequest.vue?vue&type=template&id=3ecc2bbe&scoped=true&"
import script from "./ContactRequest.vue?vue&type=script&lang=js&"
export * from "./ContactRequest.vue?vue&type=script&lang=js&"
import style0 from "./ContactRequest.vue?vue&type=style&index=0&id=3ecc2bbe&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ecc2bbe",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VForm } from 'vuetify/lib/components/VForm';
installComponents(component, {VDivider,VForm})
